export const DRUG_COUNT_PER_COUNTRY_FETCH_SUCCESSFULLY = 'DRUG_COUNT_PER_COUNTRY_FETCH_SUCCESSFULLY';
export const DRUGS_FETCH_SUCCESSFULLY = 'DRUGS_FETCH_SUCCESSFULLY';
export const DRUGS_LOADING = 'DRUGS_LOADING';
export const DRUGS_COUNTRY_ATC = 'DRUGS_COUNTRY_ATC'
export const ATC_STATISTICS_FETCH_SUCCESSFULLY = 'ATC_STATISTICS_FETCH_SUCCESSFULLY';
export const DRUGS_PER_ATC_FETCH_SUCCESSFULLY = 'DRUGS_PER_ATC_FETCH_SUCCESSFULLY';
export const COVERED_COUNTRIES_FETCH_SUCESSFULLY = 'COVERED_COUNTRIES_FETCH_SUCESSFULLY';
export const DRUG_LOADING = 'DRUG_LOADING';
export const DRUG_FETCH_SUCCESSFULLY = 'DRUG_FETCH_SUCCESSFULLY';
export const COUNT_PER_COUNTRIES_BY_ACTIVE_SUBSTANCE_SUCCESS = 'COUNT_PER_COUNTRIES_BY_ACTIVE_SUBSTANCE_SUCCESS';
export const COUNT_PER_COUNTRIES_BY_BRAND_NAME_SUCCESS = 'COUNT_PER_COUNTRIES_BY_BRAND_NAME_SUCCESS';
export const COUNTRY_STATISTICS_FETCH_SUCCESSFULLY = 'COUNTRY_STATISTICS_FETCH_SUCCESSFULLY';
export const OPPONENT_COUNTRY_STATISTICS_FETCH_SUCCESSFULLY = 'OPPONENT_COUNTRY_STATISTICS_FETCH_SUCCESSFULLY';
export const CLEAR_SELECTED_COUNTRY = 'CLEAR_SELECTED_COUNTRY';
export const DRUGS_COUNT_PER_MANUFACTURER_FETCH_SUCCESSFULLY = 'DRUGS_COUNT_PER_MANUFACTURER_FETCH_SUCCESSFULLY';
export const COMPANY_SEARCH_RESULT_SUCCESS = 'COMPANY_SEARCH_RESULT_SUCCESS';
export const COMPANY_STATISTICS_FETCH_SUCCESS = 'COMPANY_STATISTICS_FETCH_SUCCESS';
export const COMPANY_STATISTICS_FETCH = 'COMPANY_STATISTICS_FETCH';
export const COMPANY_OPPONENT_STATISTICS_FETCH_SUCCESS = 'COMPANY_OPPONENT_STATISTICS_FETCH_SUCCESS';
export const COMPANY_OPPONENT_STATISTICS_FETCH = 'COMPANY_OPPONENT_STATISTICS_FETCH';
export const COMPANY_TIMELINE_LOAD = 'COMPANY_TIMELINE_LOAD';
export const COMPANY_TIMELINE_LOAD_SUCCESS = 'COMPANY_TIMELINE_LOAD_SUCCESS';
export const COMPANY_COUNTRIES_LOAD = 'COMPANY_COUNTRIES_LOAD'
export const COMPANY_OPPONENT_COUNTRIES_LOAD = 'COMPANY_OPPONENT_COUNTRIES_LOAD'
export const CLEAR_OPPONENT_SELECTION = 'CLEAR_OPPONENT_SELECTION';
export const COUNTRY_TIMELINE_LOAD_SUCCESS = 'COUNTRY_TIMELINE_LOAD_SUCCESS';
export const COUNTRY_TIMELINE_LOAD = 'COUNTRY_TIMELINE_LOAD';
export const COUNTRIES_FETCH_SUCCESSFULLY = 'COUNTRIES_FETCH_SUCCESSFULLY';
export const COUNTRIES_ATC_PERCENTAGES_FETCH = 'COUNTRIES_ATC_PERCENTAGES_FETCH'
